import { Mapper } from "../../../../base/utils/mapper";
import { TeleconsultaInterestStateModel } from "../../../../domain/models/comercial/teleconsulta-interest-state.model";
import { TeleconsultaInterestStateEntity } from "../entities/teleconsulta-interest-state.entity";

export class TeleconsultaInterestStateImplementationRepositoryMapper extends Mapper<TeleconsultaInterestStateEntity, TeleconsultaInterestStateModel> {
    mapFrom(param: TeleconsultaInterestStateEntity): TeleconsultaInterestStateModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message
        };
    }
    mapTo(param: TeleconsultaInterestStateModel): TeleconsultaInterestStateEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message
        }
    }
}
